import { Component } from "@angular/core";

@Component({
    selector: 'app-keys',
    templateUrl: './_keys.component.html',  
})

export class _Keys{

}